import { jsx as _jsx } from "react/jsx-runtime";
import { Popover, PopoverSize, PopoverType, usePopoverHandlers } from '@as/cotopaxi';
import { ConditionalWrapper, useIsClient } from '@yonderland/andes-react';
import { useEffect, Children, cloneElement, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetSelectedProductTab } from '../../../redux/product/selectors/ProductSelector';
export const PDP_TABS_PORTAL_NAME = 'product-detail-tab-popover-portal';
export const ProductDetailTabPopover = ({ children, tabType, title, popoverFooterElement, withPortal = false, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const isClient = useIsClient();
    const selectedTab = useSelector(makeGetSelectedProductTab());
    const onPopoverClose = () => {
        setIsOpen(false);
        dispatch(productActions.createSetSelectedProductTab(null));
    };
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({ close: onPopoverClose });
    useEffect(() => {
        if (tabType === selectedTab) {
            setIsOpen(true);
        }
    }, [selectedTab]);
    useEffect(() => {
        isOpen ? handlePopoverOpen(null, null, true) : handlePopoverClose();
    }, [isOpen]);
    return (_jsx(ConditionalWrapper, { condition: isClient && withPortal, wrapper: children => createPortal(children, document.getElementById(PDP_TABS_PORTAL_NAME)), children: _jsx(Popover, { shouldAlwaysRender: true, anchorEl: anchorEl, type: PopoverType.DRAWER, onClose: handlePopoverClose, title: title, size: PopoverSize.DRAWER_LARGE, noFooterShadow: true, footerElement: popoverFooterElement, children: Children.map(children, child => child && cloneElement(child, Object.assign(Object.assign({}, child.props), { isPopoverOpen: isOpen }))) }) }));
};
